import { useTranslation } from 'react-i18next';

import FieldConfiguration from './FieldConfiguration';

export default function FieldsList({ fields, updateField, removeField, getFieldTypeLabel, collections = [] }) {
  const { t } = useTranslation();

  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
      <h3 className="text-sm font-medium text-gray-900 mb-4">{t('customCollections.form.fields.title')}</h3>

      <div className="space-y-3">
        {fields.map((field) => (
          <FieldConfiguration
            key={field.id}
            field={field}
            updateField={updateField}
            removeField={removeField}
            getFieldTypeLabel={getFieldTypeLabel}
            collections={collections}
          />
        ))}
      </div>
    </div>
  );
}
